import { HeroActions, HeroHeadline, HeroStatus, HeroSubtitle, HorizontalLogo } from "@/components/hero/HeroShared";

export const BHeroCopy = ({ prefix, eyebrow, brand = true, headlineSize = "lg:text-[3.1rem] xl:text-[3.6rem]", className = "" }) => (
  <div className={`min-w-0 ${className}`}>
    {brand && <div data-testid={`${prefix}-brand`} className="flex flex-wrap items-center gap-x-5 gap-y-3 fade-up">
      <HorizontalLogo testId={`${prefix}-horizontal-logo`} className="h-10 sm:h-12" />
      <span aria-hidden="true" className="hidden sm:block w-px h-10 bg-[#D5D8DD]" />
      <span className="flex flex-col gap-1.5">
        <span className="font-mono-label text-[11px] !tracking-normal text-[#0F1117]">Data Center Youngbloods</span>
        <HeroStatus testId={`${prefix}-status`} />
      </span>
    </div>}
    {eyebrow && (
      <p data-testid={`${prefix}-eyebrow`} className="mt-9 inline-flex items-center gap-2.5 font-mono-label text-[11px] !tracking-normal text-[#078552] fade-up delay-100">
        <span aria-hidden="true" className="w-6 h-px bg-[#10B981]" />{eyebrow}
      </p>
    )}
    <HeroHeadline testId={`${prefix}-headline`} lineBreak={false} className={`${eyebrow ? "mt-4" : brand ? "mt-9" : "mt-0"} text-[2.1rem] min-[390px]:text-[2.3rem] sm:text-5xl ${headlineSize} fade-up delay-100`} />
    <HeroSubtitle testId={`${prefix}-subtitle`} className="mt-6 max-w-xl text-[#3D4049] fade-up delay-200" />
    <HeroActions prefix={prefix} className="mt-8 fade-up delay-300" />
  </div>
);

export const B_GRID_BG = {
  backgroundImage: "linear-gradient(to right, rgba(15,17,23,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(15,17,23,0.05) 1px, transparent 1px)",
  backgroundSize: "80px 80px",
  maskImage: "radial-gradient(1000px 640px at 70% 40%, #000 25%, transparent 75%)",
  WebkitMaskImage: "radial-gradient(1000px 640px at 70% 40%, #000 25%, transparent 75%)",
};
